import { CardLevelError, PageLevelError } from './Errors';

const errorComponentDictionary = {
  cardLevel: CardLevelError,
  pageLevel: PageLevelError,
};

export default errorComponentDictionary;
